import { styled } from '@mui/system';
import Button, { ButtonProps } from '@mui/material/Button';
import React from 'react';

const ColorDisabledButton = styled(Button)<ButtonProps>(({ theme }) => ({
  color: theme.palette.getContrastText('#B53E3F'),
  width: '148px',
  height: '42px',
  borderRadius: '51px',
  backgroundColor: '#7CA7BF',
  '&:hover': {
    backgroundColor: '#7CA7BF',
    boxShadow: '0 0 30px rgba(0, 0, 0, 0.50)',
  },
}));

// eslint-disable-next-line import/prefer-default-export
export function DisabledButton(value: string) {
  return <ColorDisabledButton>{value}</ColorDisabledButton>;
}
